import {
  getImmutableCompatible,
  getFromImmutableStateCompatible,
} from 'src/utils/immutableUtils';
import { createSelector } from '@reduxjs/toolkit';
import { getIsWhitelabel } from '../view/selectors';

export const _getCashbackData = (state) =>
  getImmutableCompatible(state, 'cashback') || {};

export const getCashbackData =
  getFromImmutableStateCompatible(_getCashbackData);

export const getCashbackPromo = createSelector(
  [getCashbackData],
  (cashback) => cashback?.promo,
);
// TODO выпилить при рефакторинге биг промо https://tracker.yandex.ru/LT-52427
export const getCashbackExperimentGroup = createSelector(
  [getCashbackData],
  (cashback) => cashback?.experimentGroup || 'default',
);

export const getCashbackExperimentResolved = createSelector(
  [getCashbackData],
  (cashback) => cashback?.experimentResolved || false,
);

export const getCashbackExperimentAnalyticsSent = createSelector(
  [getCashbackData],
  (cashback) => cashback?.experimentAnalyticsSent || false,
);

const getCashbackSettings = createSelector(
  [getCashbackData],
  (cashback) => cashback?.data?.cashback,
);

// Селектор для получения цвета фона лейбла кешбэка
export const getCashbackLabelBackgroundColor = createSelector(
  [getCashbackPromo, getCashbackSettings],
  (promo, cashbackSettings) =>
    promo?.label_background_color || cashbackSettings?.label_background_color,
);

// Селектор для получения цвета текста кешбека
export const getCashbackLabelTextColor = createSelector(
  [getCashbackPromo, getCashbackSettings],
  (promo, cashbackSettings) =>
    promo?.label_text_color || cashbackSettings?.label_text_color,
);

// Селектор для получения иконки кешбека в формате webp
export const getCashbackIconWebp = createSelector(
  [getCashbackPromo, getCashbackSettings],
  (promo, cashbackSettings) =>
    promo?.icon || cashbackSettings?.icon?.webp || null,
);

// Селектор для получения иконки кешбека в формате webp
export const getCashbackIconPng = createSelector(
  [getCashbackPromo, getCashbackSettings],
  (promo, cashbackSettings) =>
    promo?.icon || cashbackSettings?.icon?.png || null,
);

// Селектор для получения лейбла кешбека
export const getCashbackLabel = createSelector(
  [getCashbackPromo, getCashbackSettings],
  (promo, cashbackSettings) => promo?.label || cashbackSettings?.label,
);

// Селектор для получения текста тултипа кешбека
export const getCashbackTooltip = createSelector(
  [getCashbackPromo, getCashbackSettings],
  (promo, cashbackSettings) => promo?.tooltip || cashbackSettings?.tooltip,
);

// Селектор для получения типа отображения тултипа кешбека
export const getCashbackTooltipDisplayMode = createSelector(
  [getCashbackSettings],
  (cashbackSettings) => cashbackSettings?.tooltip_display_mode,
);

// Селектор для получения статуса активации кешбека для партнера
export const getActivateCashbackForPartner = createSelector(
  [getCashbackSettings, getIsWhitelabel],
  (cashbackSettings, isWhiteLabel) => {
    if (isWhiteLabel && cashbackSettings?.disabled) {
      return false;
    }
    return true;
  },
);

// Селектор для получения флага показа Альфа миль
export const getAlfaMilesEnabled = createSelector(
  [getCashbackData],
  (cashback) => cashback?.data?.alfa_miles_enabled ?? false,
);
